import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, mergeMap, of } from 'rxjs';
import {
  findProductStock,
  findProductStockFailure,
  findProductStockSuccess,
} from '../actions/product-stock.actions';
import { ProductStockGatewayService } from '../gateway/product-stock.gateway';

@Injectable({
  providedIn: 'any',
})
export class ProductStockEffects {
  private actions$ = inject(Actions);
  private productStockService = inject(ProductStockGatewayService);

  findStoresWithStock$ = createEffect(() =>
    this.actions$.pipe(
      ofType(findProductStock),
      map((action) => action),
      mergeMap((payload) =>
        this.productStockService
          .search(
            payload.productCodes,
            payload.queryText,
            payload.searchConfig,
            payload.longitudeLatitude,
          )
          .pipe(
            map((data) => {
              return findProductStockSuccess({
                stores: data,
              });
            }),
            catchError((errorMessage: string) =>
              of(
                findProductStockFailure({
                  errorMessage,
                }),
              ),
            ),
          ),
      ),
    ),
  );
}
